import { publicAsset } from '../lib/assets';
import { createEl } from '../lib/dom';
import type { AttrMap } from '../lib/dom';
import { SITE } from '../site/site-config';

function storeBadgeLink(
  href: string,
  ariaLabel: string,
  variant: 'android' | 'ios',
  imagePath: string,
): HTMLElement {
  const external = href.startsWith('http');
  const attrs: AttrMap = {
    href,
    className: `sv-store-badge sv-store-badge--${variant}`,
    'aria-label': ariaLabel,
    ...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
  };
  return createEl('a', attrs, [
    createEl('img', {
      className: 'sv-store-badge__img',
      src: publicAsset(imagePath),
      alt: '',
      decoding: 'async',
      loading: 'lazy',
      'aria-hidden': 'true',
    }),
  ]);
}

/**
 * Bloque de texto + badges: **Android primero**, luego iOS.
 */
export function createStoresBlock(options: { variant: 'hero' | 'footer'; showHeadline?: boolean }): HTMLElement {
  const { variant, showHeadline = true } = options;
  const wrapClass = variant === 'hero' ? 'sv-hero__stores' : 'sv-footer__stores';
  const wrap = createEl('div', { className: wrapClass });

  if (showHeadline) {
    wrap.appendChild(
      createEl('p', { className: 'sv-stores__headline' }, [SITE.storesHeadline])
    );
  }

  const row = createEl('div', { className: 'sv-store-badges' });
  row.appendChild(
    storeBadgeLink(
      SITE.playStoreUrl,
      'Descargar Servave en Google Play para Android',
      'android',
      'badges/google-play.png',
    ),
  );
  row.appendChild(
    storeBadgeLink(
      SITE.appStoreUrl,
      'Descargar Servave en App Store para iOS',
      'ios',
      'badges/app-store.png',
    ),
  );
  wrap.appendChild(row);
  return wrap;
}
